import Joi from 'joi'
import dayjs from 'dayjs'
import AbstractModel from './AbstractModel'
import BigNumber from 'bignumber.js'

class TimeSmoothLock extends AbstractModel {
  static propTypes = {
    amount: Joi.string(),
    fromTime: Joi.string(),
    toTime: Joi.string(),
    withdrawnAmount: Joi.string(),
  }

  get amountPlusManualTransfer () {
    if (this.fromTime === '1666101600' && this.toTime === '1760796000') { // plus 30 %
      return new BigNumber(this.amount).dividedBy(70).multipliedBy(100).toFixed(0)
    }
    return this.amount
  }

  get fromDateFormatted () {
    return dayjs.unix(this.fromTime).format('MM.DD.YYYY h:mm A')
  }

  get toDateFormatted () {
    return dayjs.unix(this.toTime).format('MM.DD.YYYY h:mm A')
  }

  get formattedAmount () {
    return new BigNumber(this.amount).dividedBy(10 ** 8).toFixed(2)
  }

  get formattedAmountPlusManualTransfer () {
    return new BigNumber(this.amountPlusManualTransfer).dividedBy(10 ** 8).toFixed(2)
  }

  get formattedWithdrawnAmount () {
    return new BigNumber(this.withdrawnAmount).dividedBy(10 ** 8).toFixed(2)
  }

  get fromDate () {
    return dayjs.unix(this.fromTime)
  }

  get vestingMonths () {
    return Math.round((this.toTime - this.fromTime) / (3600 * 24 * 30.39))
  }

  get reachedFromTime () {
    return dayjs.unix(this.fromTime).isAfter(dayjs())
  }

  // name: Joi.string(),
  // blockchain: Joi.number().valid(),
  // address: Joi.string().default('0x0000000000000000000000000000000000000000'),
  // decimals: Joi.number().default(18),
  // digitsAfterDecimalShow: Joi.number().default(2),

  // get isBaseCurrency () {
  //   return (this.name === 'ETH' && this.blockchain === BLOCKCHAIN_ETHEREUM) ||
  //     (this.name === 'BNB' && this.blockchain === BLOCKCHAIN_BINANCE) ||
  //     (this.name === 'MATIC' && this.blockchain === BLOCKCHAIN_POLYGON)
  // }
  //
  // get baseUnits () {
  //   return Math.pow(10, this.decimals)
  // }
}

export default TimeSmoothLock
